import React, { useEffect } from "react"
import store from "redux/store"
import { get } from "lodash"

import { tableColumns } from "config/table_columns"
import { BaseTable } from "components/molecules/table"
import { APIResponse } from "redux/apis/types"
import { PAGE_NUM, SECURITY_TYPE } from "config/const"
import { useRelationSymbolRanking } from "components/actions/symbolDetail"
import { Labels } from "components/atoms/input/input"
import { Pagination } from "components/molecules/pagination"
import { checkIsSp } from "utils/util"
import { showSymbol, refreshSymbol } from "redux/ducks/SymbolDetail"
import { useSelector } from "react-redux"

type DetailPropsType = {
  symbolDetail: APIResponse.Res
}
export const Relation: React.FC<DetailPropsType> = props => {
  const symbol = get(props.symbolDetail, "Symbol")
  const isJPEquity = get(symbol, "SecurityType") === SECURITY_TYPE.Equity.id
  const isSp = checkIsSp()
  const isRefresh = useSelector(
    (state: { symbolDetail: { refresh: boolean } }) =>
      state.symbolDetail.refresh
  )
  const [data, page, setPage, type, changeType] = useRelationSymbolRanking(
    symbol,
    isJPEquity ? 0 : 1,
    isRefresh
  )
  //sp用
  const [spData, spPage, setSpPage] = useRelationSymbolRanking(
    symbol,
    1,
    isRefresh,
    true
  )

  useEffect(() => {
    isRefresh && store.dispatch(refreshSymbol())
  }, [isRefresh])

  return (
    <div className="panel-relation-symbol">
      <div className="filter-control-item">
        {!isSp && isJPEquity ? (
          <Labels
            className="btn-segmented-control btn-thin liquid-control"
            labelList={[
              { name: "東証33業種", id: 0 },
              { name: "S&P業種", id: 1 },
            ]}
            checked={type}
            onChange={(id: number) => changeType(id)}
          />
        ) : null}
      </div>
      {isJPEquity && !type ? (
        <div className="panel-splits panel-split-price-col">
          <div className="title-table-container">
            <div className="title-border">東証33業種TOP50</div>
            <BaseTable
              className="table table-striped"
              list={tableColumns.symbolDetail.relation(isSp)}
              data={get(data, "ResultList")}
              onClick={(data: object) => store.dispatch(showSymbol(data))}
            />
            <Pagination
              list={get(data, "ResultList")}
              total={get(data, "TotalCount")}
              current={page}
              page={PAGE_NUM.PAGE_20}
              changePage={setPage}
            />
          </div>
        </div>
      ) : null}
      {isSp || type === 1 ? (
        <div className="panel-splits panel-split-price-col">
          <div className="title-table-container">
            <div className="title-border">S&P業種TOP50</div>
            <BaseTable
              className="table table-striped"
              list={tableColumns.symbolDetail.relation(isSp)}
              data={get(isSp ? spData : data, "ResultList")}
              onClick={(data: object) => store.dispatch(showSymbol(data))}
            />
            <Pagination
              list={get(isSp ? spData : data, "ResultList")}
              total={get(isSp ? spData : data, "TotalCount")}
              current={isSp ? spPage : page}
              page={PAGE_NUM.PAGE_20}
              changePage={isSp ? setSpPage : setPage}
            />
          </div>
        </div>
      ) : null}
    </div>
  )
}
